import { mangaList, type Manga } from "@/mocks/mangaList";
import MangaCard from "@/components/feature/MangaCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface RelatedMangaProps {
  current: Manga;
}

export default function RelatedManga({ current }: RelatedMangaProps) {
  const related = mangaList
    .filter((m) => m.id !== current.id && m.categories.some((c) => current.categories.includes(c)))
    .slice(0, 4);

  const fallback = related.length > 0 ? related : mangaList.filter((m) => m.id !== current.id).slice(0, 4);

  return (
    <section aria-labelledby="related-heading">
      <SectionHeading title="相关漫画推荐" subtitle="和《家庭教师》一样精彩的热血作品" moreTo="/category" moreLabel="更多作品" />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {fallback.map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>
    </section>
  );
}